<div class="rounded-2xl bg-white p-[16px] shadow-[0px_0px_8px_0px_rgba(0,0,0,0.12)]">
  <app-filters [filters]="filters()" (filtersChange)="onApplyFilters($event)" />

  <app-offer-table-component
    [offers]="offersData()"
    [state]="state()"
    [errorMessage]="errorOffers()"
    [isFiltersApplied]="isFilterApplied()"
    (viewOffer)="onNavigateToOffer($event)"
    (editOffer)="onNavigateToEditOffer($event)"
    (deleteOffer)="onDeleteOffer($event)"
    (toggleOfferActivation)="onActiveConfirmationModal($event)" />
</div>

@if (state() === "success") {
  <app-pagination
    [itemsPerPage]="pageSize()"
    [currentPage]="currentPage()"
    [getPageNumbers]="pageNumbers()"
    [totalPages]="totalPages()"
    [startItem]="startItem()"
    [endItem]="endItem()"
    [totalItems]="totalItems()"
    (previousPage)="goToPage(currentPage() - 1)"
    (nextPage)="goToPage(currentPage() + 1)"
    (goToPage)="goToPage($event)"
    (changePageNumber)="onPageSizeChange(+$event)" />
}

@if (confirmationModal()) {
  <app-confirmation-dialog
    [error]="errorActivation()"
    (onSubmit)="type() === 'deactivate' ? deactivateOffer() : activateOffer()"
    (onCancel)="confirmationModal.set(false)"
    [title]="
      isArabic()
        ? type() === 'deactivate'
          ? 'تأكيد إلغاء تفعيل العرض'
          : 'تأكيد تفعيل العرض'
        : type() === 'deactivate'
          ? 'Confirm Offer Deactivation'
          : 'Confirm Offer Activation'
    "
    [description]="confirmationModalContent().description"
    [confirmContent]="confirmationModalContent().confirmContent"
    [type]="type()"
    [cancelContent]="isArabic() ? 'إلغاء' : 'Cancel'" />
}

@if (deleteConfirmationModal()) {
  <app-confirmation-dialog
    [error]="errorDelete()"
    [title]="isArabic() ? 'تأكيد الحذف؟' : 'Confirm Delete?'"
    [description]="
      isArabic() ? 'هل أنت متأكد من رغبتك في حذف هذا العرض؟' : 'Are you sure you want to delete this offer?'
    "
    [confirmContent]="loadingDelete() ? (isArabic() ? 'جارٍ الحذف...' : 'Deleting...') : isArabic() ? 'حذف' : 'Delete'"
    [cancelContent]="isArabic() ? 'إلغاء' : 'Cancel'"
    (onSubmit)="confirmDelete()"
    (onCancel)="deleteConfirmationModal.set(false)" />
}

@if (isSuccessNotification()) {
  <app-successful-notification
    type="success"
    [title]="
      isArabic()
        ? type() === 'deactivate'
          ? 'تم إلغاء تفعيل العرض'
          : 'تم تفعيل العرض'
        : type() === 'deactivate'
          ? 'Offer deactivated successfully. The offer is now hidden from customers.'
          : 'Offer activated successfully. The offer is now visible to customers.'
    " />
}

@if (deleteSuccess()) {
  <app-successful-notification
    type="success"
    [title]="isArabic() ? 'تم حذف العرض بنجاح.' : 'Offer deleted successfully.'" />
}
